import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";
import { APP_MODALS, MODAL_IDS } from "./constant";
import { createEntitySelectors } from "../utils/createEntitySelectors";
import { TAppModal, TModalsIds } from "./types";

export const selectModalState = (state: RootState) => state.modalState;

export const selectAppModals = createSelector(
  selectModalState,
  (state) => state.appModals,
);

export const selectAppModalById = (id: keyof typeof APP_MODALS) =>
  createSelector(selectAppModals, (appModals) => appModals[id]);

export const modalSelectors = createEntitySelectors<TAppModal, TModalsIds>(
  selectAppModals,
  MODAL_IDS,
);
